/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedArrowLeft = createReactComponent(
  "square-rounded-arrow-left",
  "IconSquareRoundedArrowLeft",
  [
    ["path", { d: "M12 8l-4 4l4 4", key: "svg-0" }],
    ["path", { d: "M16 12h-8", key: "svg-1" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-2"
      }
    ]
  ]
);

export { IconSquareRoundedArrowLeft as default };
//# sourceMappingURL=IconSquareRoundedArrowLeft.js.map
